const generateId = (() => {
  let counter = 0
  return (prefix = 'id') => {
    counter += 1
    return `${prefix}-${counter}`
  }
})()

export const useUniqueId = (prefix?: string) => {
  return { generateId: () => generateId(prefix) }
}
